/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=66461c82"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\10938\\Desktop\\ysjf1\\采购\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__